import { api } from './axios';

/**
 * Duel Verdicts API — Вердикты судей с оценками и текстовым обоснованием
 * @see api_duel_verdict_reference.md
 */

/**
 * Выставить вердикт судьи для трека в раунде
 * @param {string} roundId - ID раунда
 * @param {Object} data - Данные вердикта
 * @param {string} data.trackId - ID трека для оценки
 * @param {number} data.score - Оценка от 1 до 10
 * @param {string} data.reasoning - Текстовое обоснование вердикта
 * @returns {Promise<Object>} Созданный вердикт
 */
export const submitVerdict = (roundId, data) => {
    return api.post(`/duels/verdicts/round/${roundId}`, data).then((res) => res.data);
};

/**
 * Обновить вердикт судьи
 * @param {string} verdictId - ID вердикта
 * @param {Object} data - Данные для обновления
 * @param {string} data.trackId - ID трека
 * @param {number} data.score - Новая оценка от 1 до 10
 * @param {string} data.reasoning - Новое обоснование
 * @returns {Promise<Object>} Обновлённый вердикт
 */
export const updateVerdict = (verdictId, data) => {
    return api.put(`/duels/verdicts/${verdictId}`, data).then((res) => res.data);
};

/**
 * Удалить вердикт судьи
 * @param {string} verdictId - ID вердикта
 * @returns {Promise<void>}
 */
export const deleteVerdict = (verdictId) => {
    return api.delete(`/duels/verdicts/${verdictId}`).then((res) => res.data);
};

/**
 * Получить все вердикты раунда с подсчётом оценок
 * @param {string} roundId - ID раунда
 * @returns {Promise<Object>} Вердикты раунда
 */
export const getRoundVerdicts = (roundId) => {
    return api.get(`/duels/verdicts/round/${roundId}`).then((res) => res.data);
};

/**
 * Получить мои вердикты в раунде
 * @param {string} roundId - ID раунда
 * @returns {Promise<Array>} Список моих вердиктов
 */
export const getMyVerdicts = (roundId) => {
    return api.get(`/duels/verdicts/round/${roundId}/my`).then((res) => res.data);
};

/**
 * Получить вердикт по ID
 * @param {string} verdictId - ID вердикта
 * @returns {Promise<Object>} Детали вердикта
 */
export const getVerdict = (verdictId) => {
    return api.get(`/duels/verdicts/${verdictId}`).then((res) => res.data);
};

export default {
    submitVerdict,
    updateVerdict,
    deleteVerdict,
    getRoundVerdicts,
    getMyVerdicts,
    getVerdict
};
